import { useTranslation } from 'react-i18next';
import PageHero from '../components/ui/PageHero/PageHero';
import PillLink from '../components/ui/PillLink/PillLink';
import moonCrescent from '../assets/img/projects/lunascope/cover.webp';
import { usePageMeta } from '../hooks/usePageMeta';
import { useLanguage } from '../i18n/useLanguage';
import styles from './NotFound.module.css';

export default function NotFound() {
    const { t } = useTranslation();
    const { localizedPath } = useLanguage();
    usePageMeta(t('meta.notFoundTitle'), t('notFound.body'));

    return (
        <div className={styles.page}>
            <PageHero
                title={t('notFound.title')}
                lead={t('notFound.body')}
                backdrop={<img src={moonCrescent} alt="" className={styles.moon} width={1200} height={900} decoding="async" />}
            >
                <div className={styles.actions}>
                    <PillLink href={localizedPath('/')} size="large" icon="arrowRight">{t('notFound.home')}</PillLink>
                    <PillLink href={localizedPath('/work')} variant="glass" size="large">{t('notFound.work')}</PillLink>
                    <PillLink href={localizedPath('/support')} variant="glass" size="large">{t('notFound.support')}</PillLink>
                </div>
            </PageHero>
        </div>
    );
}
